export default "__VITE_ASSET__BTdjNHT2__"